import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import ContextDevTool from 'react-context-devtool';
import unsaveAlertReducer, { initialState } from '../reducers/unsaveAlertReducer';

export const UnsaveAlertContext = createContext();

const UnsaveAlertProvider = ({ children }) => {
  const useUnsaveAlertState = useReducer(unsaveAlertReducer, initialState);

  return (
    <UnsaveAlertContext.Provider value={[...useUnsaveAlertState]}>
      <ContextDevTool
        context={UnsaveAlertContext}
        id="UnsaveAlertContext"
        displayName="UnsaveAlert Context"
      />
      {children}
    </UnsaveAlertContext.Provider>
  );
};

UnsaveAlertProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default UnsaveAlertProvider;
